import styled from "@emotion/styled";
import { getInputFieldHeightValue } from "../../../../util/inputFieldBaseProps";
import { formInputTheme } from "../../../textinput/styled/formInputTheme";
import { TypeRampV2 } from "../../../typography";
import { selectV2Theme } from "../selectV2Theme";
export const SelectPlaceholderStyled = styled(TypeRampV2)`
    color: ${_ref => {
  let {
    themeMode
  } = _ref;
  return `var(--sds--form--color--placeholder, ${formInputTheme.placeholderColor.hover(themeMode)})`;
}};

    position: absolute;
    top: ${_ref2 => {
  let {
    themeMode,
    inputFieldHeight
  } = _ref2;
  return formInputTheme.placeholderTop[getInputFieldHeightValue(themeMode, inputFieldHeight)](themeMode);
}};
    margin-top: auto;
    margin-bottom: auto;
    left: ${_ref3 => {
  let {
    hasContentBefore,
    themeMode
  } = _ref3;
  return hasContentBefore ? selectV2Theme.input.padding.placeholder(themeMode) : selectV2Theme.input.padding.left(themeMode);
}};

    user-select: none;
    right: 30px;
    text-align: left;
    pointer-events: none;
`;
//# sourceMappingURL=SelectPlaceholderStyled.js.map